// ConsultationFeedback/PsychologistFeedbacks.tsx
import React from 'react';
import {axios} from 'Auth/axiosConfig';
import {useTheme} from 'Theme/ThemeContext';
import ConsultationFeedbackItem from "../ConsultationFeedback/ConsultationFeedbackItem";
import {IConsultationFeedback} from "../../Types/psychology/consultation";
import {useErrorProcessing} from "Core/components/ErrorProvider";
import {FC, FRSC} from "WideLayout/Layouts";
import PaginatedList from 'Core/components/elements/PaginatedList';

interface PsychologistFeedbacksProps {
    psychologistUserId: number;
}

const PsychologistFeedbacks: React.FC<PsychologistFeedbacksProps> = ({psychologistUserId}) => {
    const {byResponse} = useErrorProcessing();
    const {plt} = useTheme();

    const loadData = async (page: number): Promise<IConsultationFeedback[]> => {
        try {
            const response = await axios.get(`/api/v1/psychologists/${psychologistUserId}/feedbacks/`, {
                params: {page, page_size: 20}
            });
            return response.data;
        } catch (e) {
            byResponse(e);
            return [];
        }
    };

    const renderItem = (feedback: IConsultationFeedback) => (
        <ConsultationFeedbackItem key={feedback.id} feedback={feedback}/>
    );

    const renderEmpty = () => (
        <FRSC p={1} color={plt.text.primary60}>
            Нет отзывов.
        </FRSC>
    );

    return (
        <FC maxH={600} scroll={'y-auto'}>
            <PaginatedList
                loadData={loadData}
                renderItem={renderItem}
                pageSize={20}
                resetTrigger={psychologistUserId}
                className="gap-2"
                style={{}}
                loadMoreAtTop={false}
                renderEmpty={renderEmpty}
            />
        </FC>
    );
};

export default PsychologistFeedbacks;
